import React from 'react'
import Menu from '../Menu/Menu'
import ServicesSection from '../ServicesSection/ServicesSection'
import Footer from '../Footer/Footer'
import {Link} from 'react-router-dom'

import BackgroundPic from '../Images/AboutUsBackground.png'
import CaigoyFamilyPic from '../Images/TheCaigoys.jpg'

//style
import './AboutUs.css'

const AboutUs = props => {
console.log(BackgroundPic);
    return (
        <div className='App'>
            <Menu />
            <div className='BodyContent'>
                <div 
                    className='BackgroundPicture'
                    style={{
                        backgroundImage: 'url(' + BackgroundPic + ')',
                    }}
                >
                    <div className='BackgroundTitle'>
                        <b>We</b> Make the <span>Canvas</span>, <b>You</b> paint the <span>picture</span>!
                    </div>

                    <img src={BackgroundPic} 
                        style={{
                            width: '100%',
                            visibility: 'hidden'
                        }}
                    />
                </div>

                <div className='AboutUsSection'>

                    <div className='AboutUsTitle'>
                        <div className='Spacer'></div>

                        <div className='TitleContainer'>
                            <div className='Title'>
                                <span>About</span> Us
                            </div>
                        </div>
                    </div>

                    <div className='AboutUsBox'>
                        <div className='AboutUsPic'>
                            <img src={CaigoyFamilyPic} />
                        </div>

                        <div className='AboutUsDescription'>
                            <p>
                                Caigoy Creations is a family-run business that 
                                can take your creation and bring it to life. We 
                                provide printing services on almost every surface. 
                                Founded in 1997 as Artech and Design, Caigoy Creations 
                                has been doing business in graphic design and 
                                media printing. We have over 20 years of experience 
                                in signs, banners, music boards, and posters. 
                            </p>

                            <p>
                                Today, we can print on almost anything within a 
                                30in x 14in x 4in dimension. Whether it’s a plastic, 
                                metal, glass, or fabric surface, we can print onto 
                                it personalized it for you. Our most popular items 
                                include customized popsockets, mylar balloons, canvas 
                                bags, magic mugs, coasters, puzzles, and much more!
                            </p>
                        </div>
                    </div>
                </div>

                <div className='ProductButtonsSection'>
                    <div className='ProductButtonsContainer'>
                        <Link className='ProductButton' to='/products' >Product Information</Link>
                        <Link className='ProductButton' to='/products/create'>Begin Creating Product</Link>
                    </div>
                </div>

                <ServicesSection />

            </div>
            <Footer />
        </div>
    )
}

export default AboutUs;